import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Arc from '../Arc';
import { LinearGradient, defaultWidth, getMeterConsts } from './const';
/**
 * Meter component used to show progress towards loan payoff, credit card utilization, etc.
 */
const Meter = ({ percentage, label, width = defaultWidth, labelFontSize, valueFontSize, textOffsetY, textOffsetBetweenY }) => {
    if (width <= 0) {
        throw new Error('Meter width cannot be <= 0');
    }
    const consumerTheme = useTheme();
    const { valueTextColor } = (consumerTheme === null || consumerTheme === void 0 ? void 0 : consumerTheme.meter) || {};
    const height = width / 2;
    const { radius, strokeWidth, center, textY, textDy, labelPt, valuePt, gradientId, gradientColor, unfilledColor } = getMeterConsts({
        width,
        height,
        isSegmentedMeter: false,
        textYManual: textOffsetY,
        textDyManual: textOffsetBetweenY,
        labelPtManual: labelFontSize,
        valuePtManual: valueFontSize
    });
    const { min, max, round } = Math;
    const validatedPercentage = min(max(round(percentage), 0), 100);
    const maxDegree = 180;
    let degrees = maxDegree;
    if (validatedPercentage > 0) {
        degrees = maxDegree - maxDegree / (100 / validatedPercentage);
    }
    return (_jsxs("svg", Object.assign({ width: width, height: height }, { children: [_jsx("defs", { children: _jsx(LinearGradient, { id: gradientId }) }), _jsx(Arc, { sweepAngle: 180 - degrees, startAngle: 180, radius: radius, strokeWidth: strokeWidth, center: center, color: gradientColor }), _jsx(Arc
            // sweepAngle and rotation calculations are for the sliver of white space between Arcs
            , { 
                // sweepAngle and rotation calculations are for the sliver of white space between Arcs
                sweepAngle: validatedPercentage === 0 ? 180 : degrees + 1, startAngle: 180, rotation: validatedPercentage === 0 ? 0 : 181 - degrees, strokeWidth: strokeWidth, center: center, radius: radius, color: unfilledColor }), _jsxs("text", Object.assign({ fontSize: `${valuePt}pt`, fontWeight: "bold", fill: valueTextColor, textAnchor: "middle", x: width / 2, y: textY, "data-cy": "meter-percentage" }, { children: [validatedPercentage, "%"] })), _jsx("text", Object.assign({ fontSize: `${labelPt}pt`, textAnchor: "middle", x: width / 2, y: textY, dy: textDy, "data-cy": "meter-label" }, { children: label }))] })));
};
export default Meter;
